import { render, staticRenderFns } from "./GameTestingGameWorkspace.vue?vue&type=template&id=9180b698&"
import script from "./GameTestingGameWorkspace.vue?vue&type=script&lang=js&"
export * from "./GameTestingGameWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./GameTestingGameWorkspace.vue?vue&type=style&index=0&id=9180b698&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports